import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/Gym.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/Restaurant.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/Room2.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/explore/Hero.tsx");
